import { makeApiCalls } from "../redux/api";

export let LEADERSHIP_ROLE_TEACHING_LEADER = 'Teaching Leader';
export let LEADERSHIP_ROLE_ADMIN_LEADER = 'Admin Leader';
export let LEADERSHIP_ROLE_GROUP_LEADER = 'Group Leader';

export let CLASS_LEADER_STATUS_ACTIVE = 'Active';
export let CLASS_LEADER_STATUS_INACTIVE = 'Inactive';
export let CLASS_LEADER_STATUS_INVITED = 'Invited';

export function getLeadershipRoleOptions() {
    return [
        {key: LEADERSHIP_ROLE_GROUP_LEADER, text: LEADERSHIP_ROLE_GROUP_LEADER, value: LEADERSHIP_ROLE_GROUP_LEADER},
        {key: LEADERSHIP_ROLE_ADMIN_LEADER, text: LEADERSHIP_ROLE_ADMIN_LEADER, value: LEADERSHIP_ROLE_ADMIN_LEADER},
        {key: LEADERSHIP_ROLE_TEACHING_LEADER, text: LEADERSHIP_ROLE_TEACHING_LEADER, value: LEADERSHIP_ROLE_TEACHING_LEADER},
    ];
}

export function sortClassLeaders(classLeaders) {
    var roleScoreMapping = {};
    roleScoreMapping[LEADERSHIP_ROLE_TEACHING_LEADER] = 1;
    roleScoreMapping[LEADERSHIP_ROLE_ADMIN_LEADER] = 2;
    roleScoreMapping[LEADERSHIP_ROLE_GROUP_LEADER] = 3;
    return classLeaders.sort((a, b) => {
        var aSortName = a.user ? (a.user.name || a.email || '') : (a.email || '');
        var bSortName = b.user ? (b.user.name || b.email || '') : (b.email || '');
        return roleScoreMapping[a.leadership_role] + aSortName > roleScoreMapping[b.leadership_role] + bSortName ? 1 : -1;
    });
}

export function filterClassLeadersForViewer(classLeaders, isTeachingLeader) {
    if (isTeachingLeader) {
        return classLeaders.slice();
    }
    return classLeaders.filter((classLeader) => classLeader.status === 'Active');
}

export function getBsfClassById(
    bsfClassId,
    dispatchTool=null
) {
    return makeApiCalls(
        [
            {
                endpoint: 'MEMBER_GET_BSF_CLASS_BY_ID',
                slugFragments: {
                    bsf_class_id: bsfClassId
                }
            }
        ],
    );
}
